import React, { createContext, useContext } from 'react'

import { ReturnedData, useLaborCostConcepts } from '../../hooks/useLaborCostConcepts'

interface Props {
  children: React.ReactNode
}

interface IExtraData {
  payrollConcepts: ReturnedData
}

interface IValue {
  extraData: IExtraData
}

const ExtraDataProviderContext = createContext<IValue | undefined>(undefined)

export const ExtraDataProvider: React.FC<Props> = ({ children }) => {
  const { concepts: data, currentAssignedLaborCost, loading, refetch } = useLaborCostConcepts()

  return (
    <ExtraDataProviderContext.Provider
      value={{
        extraData: {
          payrollConcepts: {
            concepts: data,
            currentAssignedLaborCost,
            loading,
            refetch,
          },
        },
      }}
    >
      {children}
    </ExtraDataProviderContext.Provider>
  )
}

export const useExtraData = () => {
  const context = useContext(ExtraDataProviderContext)
  if (context === undefined) {
    throw new Error('useExtraData must be used within a ExtraDataProvider')
  }
  return context
}
